import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const FullBlueContent = ({ text }) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="full-blue-content">
                <div className="full-blue-content__wrapper">
                    {text.map((item, index) => {
                        return (
                            <div key={index} className="full-blue-content__text">
                                {parse(item)}
                            </div>
                        );
                    })}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default FullBlueContent;
